import React, { Fragment } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useLimitsRules } from "../hooks/use-limits-rules";
import { ErrorNumberInput } from "./error-number-input";

export const ProductLimits = ({ isCustomSLA }) => {
    const { control, setError, clearErrors, trigger } = useFormContext();
    const slaProductLimitsFields = useLimitsRules(
        (field, message) => {
            setError(`${field}Warning`, { type: "warning", message });
        },
        (field) => {
            clearErrors(`${field}Warning`);
        }
    );

    return (
        <>
            <table className="sla-table">
                <thead>
                    <tr>
                        <th />
                        <th>Weekly:</th>
                        <th>Monthly:</th>
                        <th>Annually:</th>
                    </tr>
                </thead>
                <tbody>
                    {slaProductLimitsFields.map((row, index) => {
                        return (
                            <tr key={index}>
                                {row.map((rowField) => {
                                    return (
                                        <td key={rowField.name}>
                                            {rowField.label ? (
                                                <div className="m-b-10 txt-bold font-gray">{rowField.label}</div>
                                            ) : (
                                                <Controller
                                                    rules={rowField.rules}
                                                    name={rowField.name}
                                                    control={control}
                                                    disabled={!isCustomSLA}
                                                    render={({ field, fieldState, formState }) => {
                                                        return (
                                                            <ErrorNumberInput
                                                                {...field}
                                                                displayZero
                                                                formState={formState}
                                                                fieldState={fieldState}
                                                                onChange={field.onChange}
                                                                onBlur={() => {
                                                                    trigger();
                                                                    field.onBlur();
                                                                }}
                                                            />
                                                        );
                                                    }}
                                                />
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};
